import React from "react";

export default function Three() {
  return (
    <div className="die-face third-face">
      <span className="dot"></span>
      <span className="dot"></span>
      <span className="dot"></span>
    </div>
  );
}
